import { MouseEvent } from 'react'
import { Earth, GitCompare } from 'lucide-react'

import { Privacy } from '../../../ControlsBar/PrivacyDropdown/types'
import { PrivacyOptionsVariant } from '../../../types'

const getIconColor = (isActive?: boolean) =>
  isActive ? 'var(--blue-500)' : 'var(--gray-900)'

const getIconProps = (size = 20, isActive = false) => ({
  size,
  color: getIconColor(isActive),
  className: 'cursor-default',
  onClick: (event: MouseEvent<SVGElement>) => {
    event.preventDefault()
    event.stopPropagation()
  },
})

const groupOnlyOption: Privacy = {
  key: 'PUBLIC',
  label: 'Group only',
  description: 'Visible to group members',
  icon: (size = 20, isActive = false) => (
    <GitCompare {...getIconProps(size, isActive)} />
  ),
}

const publicOption: Privacy = {
  key: 'PUBLIC',
  label: 'Public',
  description: 'Visible to everyone',
  icon: (size = 20, isActive = false) => (
    <Earth {...getIconProps(size, isActive)} />
  ),
}

const publicOptions: Privacy[] = [publicOption]

const privateOptions: Privacy[] = [groupOnlyOption]

const getGroupChannelPrivacyOptions = (
  privacyOptionsVariant?: PrivacyOptionsVariant,
): Privacy[] => {
  switch (privacyOptionsVariant) {
    case PrivacyOptionsVariant.GroupChannelPublicPost:
      return publicOptions
    case PrivacyOptionsVariant.GroupChannelPublicReply:
      return publicOptions
    case PrivacyOptionsVariant.GroupChannelPrivatePost:
      return privateOptions
    case PrivacyOptionsVariant.GroupChannelPrivateReply:
      return privateOptions
    default:
      return []
  }
}

export default getGroupChannelPrivacyOptions
